import React, {Component, useEffect, useState} from 'react';
import * as management from "../../actions/management";
import * as auth from "../../actions/auth";
import connect from "react-redux/es/connect/connect";
import {TabView, TabPanel} from 'primereact/tabview';
import {Toast} from 'primereact/toast';
import '../../css/picklist.css';
import RoleFunctions from './components/RoleFunctions';
import RoleFunctionGroups from './components/RoleFonctionGroups';
import RoleGroups from "./components/RoleGroups";

const RoleManagement = (props) => {

    const [tabActiveIndex, setTabActiveIndex] = useState(1);
    const [modules, setModules] = useState([]);

    const roleListRole = !!localStorage.getItem('role_list');

    const showSuccess = (message) => {
        this.toast.show({severity: 'success', summary: message, detail: ''});
    }

    const showError = (message) => {
        this.toast.show({severity: 'success', summary: message, detail: ''});
    }
    useEffect(() => {
        getModules();

    }, []);

    const getModules = () => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            headers["Authorization"] = `Token ${token}`;
            fetch('/api/module/list/', {headers,})
                .then(res => {
                    if (res.status < 500) {
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        //console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        const data = res.data;
                        setModules(data)
                    } else if (res.status === 401) {
                        props.loadUser();
                        throw res.data;
                    } else if (res.status === 403) {
                        throw res.data;
                    }
                })
        }
    }

    if (roleListRole) {
        return (
            <div>
                <Toast ref={(el) => this.toast = el}/>

                <div className="content-section implementation">
                    <TabView
                        activeIndex={tabActiveIndex}
                        onTabChange={(e) => setTabActiveIndex(e.index)}
                    >
                        <TabPanel header="Fonksiyonlar" rightIcon="pi pi-user">
                            <RoleFunctions/>
                        </TabPanel>

                        <TabPanel header="Fonksiyon Grupları" rightIcon="pi pi-user">

                            <RoleFunctionGroups
                                modules={modules}
                                management={props.management}
                                showSuccess={showSuccess}
                                showError={showError}
                                deleteMethod={props.deleteMethod}
                                putMethod={props.putMethod}
                                postMethod={props.postMethod}
                            />

                        </TabPanel>

                        <TabPanel header="Rol Grupları" rightIcon="pi pi-user">
                            <RoleGroups
                                modules={modules}
                                management={props.management}
                                showSuccess={showSuccess}
                                showError={showError}
                                deleteMethod={props.deleteMethod}
                                putMethod={props.putMethod}
                                postMethod={props.postMethod}
                            />
                        </TabPanel>
                    </TabView>

                </div>
            </div>
        )
        // } else {
        //     return (
        //         <div>
        //             <center>
        //                 <ProgressSpinner
        //                     style={{marginTop: '200px', width: '50px', height: '50px'}}
        //                     strokeWidth="8"
        //                     fill="#EEEEEE"
        //                     animationDuration=".5s"/>
        //             </center>
        //         </div>
        //     )
        // }

    } else {
        return (
            <div className="p-fluid">
                <div className="p-grid">
                    <Toast ref={(el) => this.toast = el}/>
                    <div className="p-col-12">
                        <h1>Yetkiniz Bulunmuyor!</h1>
                    </div>
                </div>
            </div>
        )
    }

}

const mapStateToProps = state => {
    return {
        user: state.auth.user,
        management: state.management,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        putMethod: (data, url, type) => {
            return dispatch(management.putMethod(data, url, type));
        },
        postMethod: (data, url, type) => {
            return dispatch(management.postMethod(data, url, type));
        },
        deleteMethod: (data, url, type) => {
            return dispatch(management.deleteMethod(data, url, type));
        },
        logout: () => dispatch(auth.logout()),
        loadUser: () => {
            return dispatch(auth.loadUser());
        },

    }
};


export default connect(mapStateToProps, mapDispatchToProps)(RoleManagement);


// WEBPACK FOOTER //
// ./src/pages/rolemanagement/RoleManagement.jsx